import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "onClick"]

import { ref, watch } from 'vue';
import DatePicker from 'primevue/datepicker';
import { useDebounceFn } from '@vueuse/core';
import SharedService from "@/services/SharedService";
import { RANGE } from '@/models/share.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'esInputDateTime',
  props: {
    id: {},
    dateTimeValue: {},
    disabled: { type: Boolean },
    min: {},
    withTime: { type: Boolean },
    dateFormat: {},
    timeOnly: { type: Boolean },
    range: { type: Boolean },
    inline: { type: Boolean },
    minDate: {},
    maxDate: {},
    isSetting: { type: Boolean },
    isInvalid: { type: Boolean },
    selectOtherMonths: { type: Boolean }
  },
  emits: ['updateDateTime', 'isDatePickerOpen', 'isDatePickerClose'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const inputDateTime = ref<Date | [Date, Date] | null>(props.dateTimeValue);

const emits = __emit

watch(
    () => props.dateTimeValue,
  () => {
    inputDateTime.value = props.dateTimeValue;
  }
);

const updateDateTimeHandler = (newDateTime: Date | Date[]) => {
  if (props.range || !props.isSetting) {
    emits('updateDateTime', newDateTime);
  } else {
    debouncedUpdateDateTime(newDateTime);
  }
};


const debouncedUpdateDateTime = useDebounceFn((newDateTime: Date | Date[]) => {
    emits('updateDateTime', newDateTime);
}, 1000);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), {
    inputId: props.id,
    modelValue: inputDateTime.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((inputDateTime).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (updateDateTimeHandler($event)))
    ],
    dateFormat: _ctx.dateFormat,
    showIcon: "",
    iconDisplay: "input",
    disabled: _ctx.disabled,
    class: "w-full",
    showTime: _ctx.withTime,
    timeOnly: _ctx.timeOnly,
    selectOtherMonths: _ctx.selectOtherMonths,
    hourFormat: "24",
    size: "small",
    selectionMode: props.range ? _unref(RANGE).RANGE : _unref(RANGE).SINGLE,
    inline: _ctx.inline,
    onShow: _cache[2] || (_cache[2] = ($event: any) => (emits('isDatePickerOpen', true))),
    onHide: _cache[3] || (_cache[3] = ($event: any) => (emits('isDatePickerClose', true))),
    minDate: _ctx.minDate,
    maxDate: _ctx.maxDate,
    invalid: props.isInvalid
  }, _createSlots({ _: 2 }, [
    (_ctx.timeOnly)
      ? {
          name: "inputicon",
          fn: _withCtx((slotProps) => [
            _createElementVNode("img", {
              src: _unref(SharedService).getIcon('clock', false, 'shareIcons'),
              onClick: slotProps.clickCallback,
              class: "img-grey"
            }, null, 8, _hoisted_1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["inputId", "modelValue", "dateFormat", "disabled", "showTime", "timeOnly", "selectOtherMonths", "selectionMode", "inline", "minDate", "maxDate", "invalid"]))
}
}

})